import { useSearchParams } from "react-router-dom";
import { portfolioAnalysisPages } from "@app/const/route.const";
import { ModuleSummaryReport } from "./ModuleSummaryReport";

export const PdfPortfolioAnalysisSummaryReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id } =
    portfolioAnalysisPages.getPdfSummaryReportParams(searchParams);

  return (
    <ModuleSummaryReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      data1Id={data1Id}
      data2Id={data2Id}
      footer="Portfolio Analysis"
    />
  );
};
